import { FC } from "react";

import BaseImage, { ImageProps } from "next/image";

type TImageProps = Omit<ImageProps, "loader"> & Partial<Pick<ImageProps, "loader">>;

const Image: FC<TImageProps> = ({ ...rest }) => <BaseImage unoptimized {...rest} />;

export default Image;
